// eslint-disable-next-line
export let drawerWidth = 240;

export let applicationTitle = 'Grantmaker Subrecipient Selection';

export const DEFAULT_FILTER_BASE_NAME = 'DEFAULT_FILTERS';
export const DATRGRID_DEFAULT_ORDER_MODEL = [];
export const DATAGRID_DEFAULT_FILER_MODEL = [];
